import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Job } from '../model/job';
import { HttpClient } from '@angular/common/http';
import { JobSerializer } from '../model/serializer/job-serializer';

import { environment } from '@environments/environment';
import { JobData } from '@app/model/job-data';
import { JobDataSerializer } from '@app/model/serializer/job-data-serializer';

@Injectable({ providedIn: 'root' })
export class JobDataService extends ApiService<JobData> {

  constructor(httpClient: HttpClient) {
    super(httpClient,
      environment.apiUrl,
      'job/job-data',
      new JobDataSerializer());
  }
}
